import { Row } from '@atom-web/micros'
import { useContext } from 'react'

import { GCM_PASSENGER_INFO, SET_ENABLE_GET_COST } from '../Constants'
import Input from '../micros/Input'

export default ({
	itineraryInfo,
	labelText,
	isLoggedIn,
	disableCountryPhoneCode = false,
	disabled,
	context,
	contextKey,
	type = GCM_PASSENGER_INFO,
	mobileNumberProps,
	...rest
}) => {
	const [state, dispatch] = useContext(context)

	const entryPoint = state?.[contextKey]

	const onChangeCountryCode = countryPhoneCode => {
		// countryPhoneCode = countryPhoneCode.replace('+', '')
		// if (isNaN(countryPhoneCode)) return false

		dispatch({
			type,
			payload: {
				countryPhoneCode: countryPhoneCode,
			},
		})

		dispatch({
			type: SET_ENABLE_GET_COST,
			payload: {
				itineraryInfo,
				isLoggedIn,
			},
		})
	}

	const onChangeMobile = mobileNumber => {
		dispatch({
			type,
			payload: {
				...entryPoint,
				mobileNumber,
				countryPhoneCode: entryPoint?.countryPhoneCode
					? entryPoint?.countryPhoneCode
					: '+91',
			},
		})

		itineraryInfo &&
			dispatch({
				type: SET_ENABLE_GET_COST,
				payload: {
					itineraryInfo,
					isLoggedIn,
				},
			})
	}
	const onValidateKeys = e => {
		let ALLOWED_KEYS = [
			'Backspace',
			'Tab',
			'Enter',
			'ArrowUp',
			'ArrowDown',
			'ArrowLeft',
			'ArrowRight',
			'Home',
			'End',
			'PageUp',
			'PageDown',
			'Delete',
		]
		if (
			!e.ctrlKey &&
			!e.altKey &&
			!ALLOWED_KEYS.includes(e.key) &&
			!/[0-9+]/g.test(e.key)
		) {
			e.preventDefault()
		}
	}

	return (
		<Row
			gap="2"
			css={{
				width: '100%',
			}}
			{...rest}
		>
			<Input
				placeholder={'+91'}
				value={entryPoint?.countryPhoneCode || '+91'}
				inputProps={{
					css: {
						paddingLeft: '$4',
						paddingTop: 0,
						width: '60px',
						display: 'flex',
						justifyContent: 'center',
						border: 'none',
						userSelect: 'none',

						'&::placeholder': {
							fontSize: '$2',
							fontWeight: '$bold',
							color: '$grey12',
						},
					},
					maxLength: 4,
				}}
				onChange={onChangeCountryCode}
				// disabled={disableCountryPhoneCode}
				animated={false}
				onKeyDown={onValidateKeys}
			/>
			<Input
				placeholder={labelText}
				value={entryPoint?.mobileNumber}
				onChange={onChangeMobile}
				wrapperProps={{
					css: {
						flex: 1,
					},
				}}
				type="number"
				inputProps={{
					css: {
						backgroundColor: '$white',
					},
					type: 'number',
					pattern: '[0-9]*',
					max: 9999999999,
					min: 1,
				}}
				disabled={disabled}
				{...mobileNumberProps}
			/>
		</Row>
	)
}
